import 'javascripts/all_pages.js'
import { stickyScroll, navTabs, jqTextExpander,  jqTextCopy } from 'javascripts/general_scripts';
import 'javascripts/comments.js'

/* stylesheet */
import 'javascripts/all_pages_styles.js'
import 'stylesheets/products/default_styles.less'
import 'stylesheets/products/deep_dive.less'

jQuery(() => {
  stickyScroll();
  navTabs();
  jqTextCopy();

  jqTextExpander();
  $('div:not(.hide-section) .full-review').expander(13);
  $('.embedded-comment-2 .comment-body').expander(4);
});

if (navigator.userAgent.includes('Firefox') && location.hash) {
    document.addEventListener('DOMContentLoaded', function (event) {
        window.scrollTo(0, 0);
    });
    window.addEventListener('load', function (event) {
        setTimeout(() => { $('html,body').animate({scrollTop: $(location.hash).offset().top}) }, 500);
    });
}
